import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

type CommuteBadgeTotalProps = {
  count: number | undefined;
  size: number;
};

export function CommuteBadgeTotal({ count, size }: CommuteBadgeTotalProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={size} key={0}>
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          display: 'flex',
          flexGrow: 1,
          justifyContent: 'center',
          alignItems: 'center',
          padding: 2,
        }}
      >
        <Box sx={{ paddingRight: 1 }}>{t(`MonitoringDailySumPreFix${count === 1 ? 'Singular' : 'Plural'}`)}</Box>
        <Box
          sx={{
            color: 'primary.main',
            fontSize: 40,
            fontWeight: 'bold',
            marginTop: '-5px',
          }}
        >
          {count !== 0 && count}
        </Box>
        <Box sx={{ paddingLeft: 1 }}>{t(`MonitoringDailySumPostFix${count === 1 ? 'Singular' : 'Plural'}`)}</Box>
      </Box>
    </Grid>
  );
}
